import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const LightningIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="3"
      {...props}
      htmlColor="transparent"
    >
      <path
        d="M25.6308 10L14.1924 34.5091C14.0331 34.8562 13.971 35.2396 14.0126 35.619C14.0542 35.9983 14.198 36.3594 14.4288 36.664C14.6624 36.9874 14.9746 37.2465 15.3363 37.4169C15.7083 37.5946 16.1148 37.6893 16.5274 37.6945H29.5538L19.387 70L64.2233 32.4294C64.5745 32.1187 64.8246 31.7108 64.9418 31.2578C65.0489 30.8114 65.0074 30.3425 64.8236 29.9216C64.6307 29.4854 64.3093 29.1179 63.9019 28.8676C63.4762 28.6122 62.9904 28.4726 62.4934 28.463H49.2212L59.388 10H25.6308Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
